import { Component, Output, EventEmitter, ViewChild, Input, SimpleChanges, OnInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, ControlContainer } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject, throwError, of } from 'rxjs';
import { takeUntil, catchError, take } from 'rxjs/operators';
import { SelectBox, TimeApiService, ApiCommonService } from 'cbc-shared-lib';
import { UsedSzza024aService } from '../../../../../sg-kb-shared/services/used-szza024a.service';
import { UsedSgkb986aService } from '../../../../../sg-kb-shared/services/used-sgkb986a.service';
import { Sgkb713dComponent } from '../../../sgkb713d/pages/sgkb713d/sgkb713d.component';
import { Sgkb714dComponent } from '../../../sgkb714d/pages/sgkb714d/sgkb714d.component';
import {
  ResponseCommon, CodeConversionMstDto, NenkanScheduleMasterDto, Szza024aRequest,
  Sgkb986aRequest, Sgkb986aResponse, Sgkb986aResCtrSearchresultDto,
  Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto,
  Sgkb702aResInclusiveCtrInfoDto, Sgkb702aResInclusiontargetDemandctrinfoDto
} from 'sg-api';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

interface NewSgkb702aResInclusiontargetDemandctrinfoDto extends Sgkb702aResInclusiontargetDemandctrinfoDto {
  /** 契約状態（prdBreakDateの有無、ctrendDate=99991231で表示切替） */
  keiyakuJotai?: string;
  /** エネルギー種別と熱量の区切り文字 */
  pipe?: string;
  /** 熱量の単位表示 */
  unitHeat?: string;
  /** 割引・割増金額の小数点含めた金額表示 */
  discountextraPointMny?: string;
  /** 割引・割増金額の単位表示 */
  unitMny?: string;
  /** 割引・割増率の単位表示 */
  unitRate?: string;
  /** 新規追加フラグ */
  registFlg?: boolean;
}

@Component({
  selector: 'app-sgkb708d-inclutagsupdemandctr',
  templateUrl: './sgkb708d-inclutagsupdemandctr.component.html',
  styleUrl: './sgkb708d-inclutagsupdemandctr.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class Sgkb708dInclutagsupdemandctrComponent implements OnInit, OnDestroy {

  /** 包括契約情報入力コンポーネントからの受領項目 */
  @Input() indisabledBotton: string;
  /** 遷移元ステータス */
  @Input() mode: string;
  /** 包括契約検索APIレスポンス */
  @Input() incCtrSearchresult: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;
  /** コード一覧 */
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 行選択情報 */
  @Output() rowClickEvent = new EventEmitter<string>();
  /** データ選択イベント */
  @Output() onSelectedEvent = new EventEmitter<any[]>();
  /** 需給契約一覧テーブル */
  @Output() dataSourceChange = new EventEmitter<MatTableDataSource<NewSgkb702aResInclusiontargetDemandctrinfoDto>>();
  /** メッセージ設定通知イベント */
  @Output() setMessageEvent = new EventEmitter<string>();
  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();

  /** ソートされた時のイベント */
  @ViewChild(MatSort) sort: MatSort;
  /** CSV取込時のイベント */
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;;
  /** 包括契約需給契約一覧FormGroup*/
  jyukyuListForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** チェックボックス */
  selectionClaimCharge = new SelectionModel<string>(true, []);
  /** チェックボックス非活性フラグ */
  chkBoxDisabled: boolean = false;
  /** 編集ボタンの非活性判定　true:非活性 */
  isEditDisabled: boolean = true;
  /** 削除ボタンの非活性判定　true:非活性 */
  isDelDisabled: boolean = true;
  /** 金額表示フラグ */
  showKingaku: boolean = true;
  /** ボタン活性制御フラグ */
  disabledBotton: boolean = true;
  /** 全ボタン表示フラグ */
  dispBotton: boolean = true;
  /** 削除ボタン表示フラグ */
  dispDelBotton: boolean = true;
  /** 割引・割増種類名称 */
  discntextraSyuruiAnameDisp: string = '';
  /** コード変換マスタから受け取る割引・割増種類コードのリスト */
  preHoukatsuHouhouList: SelectBox[] = [];
  /** 年間スケジュールマスタ照会 */
  nenkanscheduleMasterDetail: NenkanScheduleMasterDto;
  /** 年間マスタ取得日付 */
  getSzza024aDate: string;
  /** 需給契約重複エラーリスト */
  errorfirstSrvctrNoList: Array<string> = [];
  /** 初期表示時の割引・割増開始日 */
  befWaribikiKaishiYMD: string;
  /** 契約検索・一覧照会 */
  sgkb986aResponse: Sgkb986aResponse;
  /** responseCommon(SGKB986A) */
  sgkb986aResponseCommon: ResponseCommon;
  /** 契約検索結果リスト */
  ctrSearchresultList: Array<Sgkb986aResCtrSearchresultDto>;

  constructor(
    private dialog: MatDialog,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    private usedSzza024aService: UsedSzza024aService,
    private usedSgkb986aService: UsedSgkb986aService,
    private cdr: ChangeDetectorRef,
  ) { }

  /** 画面表示用の設定リスト */
  setDisplayedColumnsCol: String[] = null;

  /** 画面表示項目 割引・割増金額 表示用 */
  displayedColumnsCol1: string[] = [
    'select',
    'firstSrvctrNo',
    'shiyouBashoJusho',
    'visitName',
    'energyClsfyCodeaname',
    'keiyakuJotai',
    'firstKenshinscheduledate',
    'discountextraStartdate',
    'discountextraUnlockdate',
    'waribikiSyurui',
    'discountextraMny',
    'prdGoodsRyaku',
    'suppntSpno',
  ];

  /** 画面表示項目 割引・割増率 表示用 */
  displayedColumnsCol2: string[] = [
    'select',
    'firstSrvctrNo',
    'shiyouBashoJusho',
    'visitName',
    'energyClsfyCodeaname',
    'keiyakuJotai',
    'firstKenshinscheduledate',
    'discountextraStartdate',
    'discountextraUnlockdate',
    'waribikiSyurui',
    'discountextraRate',
    'prdGoodsRyaku',
    'suppntSpno',
  ];

  dataSource = new MatTableDataSource<NewSgkb702aResInclusiontargetDemandctrinfoDto>();

  /**
   * 購読を停止する処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 初期表示時
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  ngOnInit(): void {

    // 画面項目の初期化
    this.setInitDisp();

    // 遷移パラメータが 登録 の場合
    if (this.mode === 'create') {
      this.chkBoxDisabled = false;
      this.dispBotton = true;
      this.disabledBotton = false;
      // 項目制御用変数の設定
      this.showKingaku = true;
      // 割引・割増金額 表示用のリストを設定
      this.setDisplayedColumnsCol = this.displayedColumnsCol1;
      return;
    }

    if (!this.incCtrSearchresult?.inclusiveCtrInfoList?.length) {
      return;
    }

    // 親コンポーネントで取得した包括契約検索APIレスポンスの業務情報を設定
    const incCtrInfoDto: Sgkb702aResInclusiveCtrInfoDto =
      this.incCtrSearchresult.inclusiveCtrInfoList[0];

    // 初期表示時
    if (!this.indisabledBotton || this.indisabledBotton == '') {
      // 包括契約検索APIレスポンスの割引・割増種類が 定額割引、環境貢献加算の場合
      if (incCtrInfoDto.discountextraSyurui === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_DISCOUNT
        || incCtrInfoDto.discountextraSyurui === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_PREMIUM) {
        // ボタン制御用変数の設定
        this.disabledBotton = false;
        // 項目制御用変数の設定
        this.showKingaku = true;
        // 割引・割増金額 表示用のリストを設定
        this.setDisplayedColumnsCol = this.displayedColumnsCol1;
        // 割引・割増種類名称
        this.discntextraSyuruiAnameDisp = incCtrInfoDto.discntextraSyuruiAname;
      }
      // 包括契約検索APIレスポンスの割引・割増種類が 定率割引、定率割増の場合
      else if (incCtrInfoDto.discountextraSyurui === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_DISCOUNT
        || incCtrInfoDto.discountextraSyurui === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_PREMIUM) {
        // ボタン制御用変数の設定
        this.disabledBotton = false;
        // 項目制御用変数の設定
        this.showKingaku = false;
        // 割引・割増率 表示用のリストを設定
        this.setDisplayedColumnsCol = this.displayedColumnsCol2;
        // 割引・割増種類名称
        this.discntextraSyuruiAnameDisp = incCtrInfoDto.discntextraSyuruiAname;
      } else {
        // ボタン制御用変数の設定
        this.disabledBotton = true;
        // 項目制御用変数の設定
        this.showKingaku = true;
        // 割引・割増金額 表示用のリストを設定
        this.setDisplayedColumnsCol = this.displayedColumnsCol1;
        // 割引・割増種類名称
        this.discntextraSyuruiAnameDisp = incCtrInfoDto.discntextraSyuruiAname;
      }
    }

    // 包括契約検索APIレスポンスの包括対象需給契約情報リストを抽出
    let indCtrInfoList: Array<NewSgkb702aResInclusiontargetDemandctrinfoDto> =
      this.incCtrSearchresult.inclusiveCtrInfoList[0].inclusiontargetDemandctrinfoList;
    // 需給契約一覧編集
    indCtrInfoList = this.editIndCtrTable(indCtrInfoList, 'init');

    // 抽出した包括対象需給契約情報リストを設定
    this.dataSource.data = indCtrInfoList;
    this.dataSourceChange.emit(this.dataSource);

    // 遷移パラメータが 登録、期中変更、包括契約更改 のいずれかの場合
    if (this.mode === 'midterm_change' || this.mode === 'renewal') {
      this.chkBoxDisabled = false;
      this.dispBotton = true;

      // 遷移パラメータが 期中変更 の場合
      if (this.mode === 'midterm_change') {
        this.dispDelBotton = false;
      }
    } else {
      this.chkBoxDisabled = true;
      this.dispBotton = false;
    }
  }

  /**
   * 画面項目の初期化（値、活性状態）
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  setInitDisp(): void {
    // チェックボックス非活性フラグ
    this.chkBoxDisabled = false;
    // 編集ボタンの非活性判定　true:非活性
    this.isEditDisabled = true;
    // 削除ボタンの非活性判定　true:非活性
    this.isDelDisabled = true;
    // 金額表示フラグ
    this.showKingaku = true;
    // ボタン活性制御フラグ
    this.disabledBotton = true;
    // 全ボタン表示フラグ
    this.dispBotton = true;
    // 削除ボタン表示フラグ
    this.dispDelBotton = true;
    // 割引・割増種類名称
    this.discntextraSyuruiAnameDisp = "";
    // コード変換マスタから受け取る割引・割増種類コードのリスト
    this.preHoukatsuHouhouList = [];
    // 年間スケジュールマスタ照会
    this.nenkanscheduleMasterDetail = null;
    // 年間マスタ取得日付
    this.getSzza024aDate = "";
    // 需給契約重複エラーリスト
    this.errorfirstSrvctrNoList = [];
    // 初期表示時の割引・割増開始日
    this.befWaribikiKaishiYMD = "";
    // 契約検索・一覧照会
    this.sgkb986aResponse = null;
    // responseCommon(SGKB986A)
    this.sgkb986aResponseCommon = null;
    // 契約検索結果リスト
    this.ctrSearchresultList = null;
    // 画面表示用の設定リスト
    this.setDisplayedColumnsCol = null;
    this.dataSource = new MatTableDataSource<NewSgkb702aResInclusiontargetDemandctrinfoDto>();
  }

  /**
   * @Input()変更時の処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    for (const prop in changes) {
      const change = changes[prop];

      if (change.currentValue !== undefined) {
        // 包括契約情報コンポーネントで割引・割増種類が変更された場合
        if (prop === 'indisabledBotton') {
          // 定額割引、環境貢献加算 選択時
          if (change.currentValue === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_DISCOUNT
            || change.currentValue === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.RATION_PREMIUM) {
            // ボタン制御用変数の設定
            this.disabledBotton = false;
            // 項目制御用変数の設定
            this.showKingaku = true;
            // 割引・割増金額 表示用のリストを設定
            this.setDisplayedColumnsCol = this.displayedColumnsCol1;
          }
          // 定率割引、定率割増 選択時
          else if (change.currentValue === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_DISCOUNT
            || change.currentValue === SgkbConstains.CODE.DISCOUNT_PREMIUM_TYPE_CD.FIXED_RATE_PREMIUM) {
            // ボタン制御用変数の設定
            this.disabledBotton = false;
            // 項目制御用変数の設定
            this.showKingaku = false;
            // 割引・割増率 表示用のリストを設定
            this.setDisplayedColumnsCol = this.displayedColumnsCol2;
          }

          // コード値レスポンスから割引・割増種類コードを取得
          let codeList: CodeConversionMstDto[] = this.codeConversionMstMap.get("S000651");
          // コード値リストから変更後の割引・割増種類のレコードを取得
          const code = codeList.find(getList => getList.userCode === change.currentValue);
          // コード値の表示内容を設定
          this.discntextraSyuruiAnameDisp = code.hyojiCont;
        }
      }
    }
  }

  /**
   * ソート処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'firstSrvctrNo':
          const firstSrvctrNo = item.firstSrvctrNo ?? '';
          return firstSrvctrNo;
        case 'shiyouBashoJusho':
          const description = item.description ?? '';
          const mptAname = item.mptAname ?? '';
          const townAreaName = item.townAreaName ?? '';
          const ooazaName = item.ooazaName ?? '';
          const bantiGoubunptgouAname = item.chomeanameIkaKanjitext ?? '';
          const supadrKanjiAname1 = item.supadrKanjiAname1 ?? '';
          const yagouAname = item.yagouAname ?? '';
          return description + mptAname + townAreaName + ooazaName
            + bantiGoubunptgouAname + supadrKanjiAname1 + yagouAname;
        case 'visitName':
          const visitName = item.visitName ?? '';
          return visitName;
        case 'energyClsfyCodeaname':
          const energyClsfyCodeaname = item.energyClsfyCodeaname ?? '';
          const heatAname = item.heatAname ?? '';
          return energyClsfyCodeaname + heatAname;
        case 'keiyakuJotai':
          const keiyakuJotai = item.keiyakuJotai ?? '';
          return keiyakuJotai;
        case 'firstKenshinscheduledate':
          const firstKenshinscheduledate = item.firstKenshinscheduledate ?? '';
          return firstKenshinscheduledate;
        case 'discountextraStartdate':
          const discountextraStartdate = item.discountextraStartdate ?? '';
          return discountextraStartdate;
        case 'discountextraUnlockdate':
          const discountextraUnlockdate = item.discountextraUnlockdate ?? '';
          return discountextraUnlockdate;
        case 'waribikiSyurui':
          const waribikiSyurui = this.discntextraSyuruiAnameDisp ?? '';
          return waribikiSyurui;
        case 'discountextraMny':
          const discountextraMny = item.discountextraMny ?? '';
          return discountextraMny;
        case 'discountextraRate':
          const discountextraRate = item.discountextraRate ?? '';
          return discountextraRate;
        case 'prdGoodsRyaku':
          const prdGoodsRyaku = item.prdGoodsRyaku ?? '';
          return prdGoodsRyaku;
        case 'suppntSpno':
          const suppntSpno = item.suppntSpno ?? '';
          return suppntSpno;
        default:
          return '';
      }
    };
    this.dataSource.sort = this.sort;
  }

  /**
   * 需給契約一覧編集
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  editIndCtrTable(setList: Array<NewSgkb702aResInclusiontargetDemandctrinfoDto>, status: string): Array<NewSgkb702aResInclusiontargetDemandctrinfoDto> {
    let returnList: Array<NewSgkb702aResInclusiontargetDemandctrinfoDto> = [];
    returnList = setList;

    if (!setList || setList.length === 0) {
      return returnList;
    }

    // 引数の個数分、処理を繰り返す
    for (let i = 0; i < setList.length; i++) {
      // 熱量のデータがある場合、熱量末尾に「MJ」を付与
      if (setList[i].heatAname && setList[i].heatAname != '') {
        returnList[i].unitHeat = 'MJ';

        // エネルギー種別のデータがある場合、熱量先頭に「／」を付与
        if (setList[i].energyClsfyCodeaname && setList[i].energyClsfyCodeaname != '') {
          returnList[i].pipe = '／';
        }
      }

      // 割引・割増金額にデータがある場合、小数点以下(.00)と単位を付与
      if (setList[i].discountextraMny && setList[i].discountextraMny != null) {
        returnList[i].discountextraPointMny = setList[i].discountextraMny.toString()
        // 末尾が.(ドット)だった場合は、末尾に00を付与
        if (returnList[i].discountextraPointMny.endsWith('.')) {
          returnList[i].discountextraPointMny = returnList[i].discountextraPointMny + '00';
        }
        // 小数点があり、かつ小数部が1桁の場合は末尾に0を付与
        else if (/^\d+\.\d$/.test(returnList[i].discountextraPointMny)) {
          returnList[i].discountextraPointMny = returnList[i].discountextraPointMny + '0';
        }
        // 小数点がなく 1〜2桁の整数の場合は末尾に.00を付与
        else if (!returnList[i].discountextraPointMny.includes('.') && /^\d{1,2}$/.test(returnList[i].discountextraPointMny)) {
          returnList[i].discountextraPointMny = returnList[i].discountextraPointMny + '.00';
        }
        returnList[i].unitMny = '円';
      }

      // 割引・割増率にデータがある場合、単位を付与
      if (setList[i].discountextraRate && setList[i].discountextraRate != null) {
        returnList[i].unitRate = '％';
      }

      // 初期表示時の場合
      if (status === 'init') {
        // 初期表示の際は新規追加フラグをtrueに設定
        returnList[i].registFlg = false;
        // サービス契約解約日付が設定されている場合
        if (setList[i].prdBreakDate) {
          // 契約状態を設定
          returnList[i].keiyakuJotai = '解約';
        } else {
          // 契約状態を設定
          returnList[i].keiyakuJotai = '契約中';
        }
      }
      // 需給契約検索画面を閉じた場合
      else if (status === 'sgkb713d') {
        // サービス契約解約日付が設定されている場合
        if (setList[i].prdBreakDate === '99991231') {
          // 契約状態を設定
          returnList[i].keiyakuJotai = '契約中';
        } else {
          // 契約状態を設定
          returnList[i].keiyakuJotai = '解約';
        }
      }
    }
    return returnList;
  }

  /**
   * CSVボタン押下処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  /**
   * CSVボタン押下処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  onClickCsvCapture(event: any): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const csvData = reader.result;
        this.processCSV(csvData);
      };
      reader.readAsText(file);
    }
  }

  /**
   * CSV読み込み後の処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  processCSV(csvData: string | ArrayBuffer | null) {
    if (typeof csvData === 'string') {
      const rowList = csvData.split('\r\n');

      // 契約検索・一覧照会レスポンスを取得
      this.usedSgkb986aService.searchContractor(this.setSgkb986aRequest(rowList))
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(response => {
          this.sgkb986aResponse = response;
          this.sgkb986aResponseCommon = response.responseCommon;
          this.ctrSearchresultList = response.ctrSearchresultList;

          // 検索結果がある場合のみ処理を実行
          if (this.ctrSearchresultList != null) {
            // 需給契約一覧登録用のリスト設定
            const sgkb713dInfoList = this.setIndCtrInfoList(this.ctrSearchresultList);
            // 需給契約の重複チェック
            const chkResult = this.chkDuplication();
            // 重複チェックがエラーの場合、処理終了
            if (chkResult) {
              return;
            }

            // 需給契約一覧登録用のリストから契約お客さま番号を抽出しリスト化
            const firstSrvctrNoList = new Set(sgkb713dInfoList.map(info => info.firstSrvctrNo));
            // 契約お客さま番号リストに含まれないCSVのお客さま番号をリスト化
            const missingFirstSrvctrNoList = rowList.filter(firstSrvctrNo => firstSrvctrNo != '' && !firstSrvctrNoList.has(firstSrvctrNo));

            // エラー処理
            if (missingFirstSrvctrNoList.length > 0) {
              const messageStr = missingFirstSrvctrNoList.join(',');

              this.clearMessageEvent.emit('');
              this.setMessageEvent.emit('契約番号：' + messageStr + 'の需給契約が存在しません。');
              return;
            }

            // CSVのお客さま番号が契約お客さま番号リストに含まれない場合、エラー設定
            let nonFirstSrvctrNo: string = '';
            rowList.forEach((firstSrvctrNo, index) => {
              if (!firstSrvctrNoList.has(firstSrvctrNo)) {
                if (index === 0) {
                  nonFirstSrvctrNo = firstSrvctrNoList[index];
                } else {
                  nonFirstSrvctrNo = nonFirstSrvctrNo + ',' + firstSrvctrNoList[index];
                }
              }
            });
            // 需給契約一覧登録用のリストを画面に反映
            this.setDataSourceView(sgkb713dInfoList);
          }
          // 変更検出を行い、ビューとデータの整合性を確保
          this.cdr.detectChanges();
        });
    }
  }

  /**
   * 契約検索・一覧照会のリクエスト設定
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  setSgkb986aRequest(rowList: Array<string>): Sgkb986aRequest {

    // ガス「01」、電気「11」
    const srvClsfyCode: string[] = [SgkbConstains.CODE.SERVICE_CLY_CD.GAS, SgkbConstains.CODE.SERVICE_CLY_CD.ELE];
    // 契約検索・一覧照会リクエストを作成
    const sgkb986aRequest: Sgkb986aRequest = {
      ctrSearchInfo: {
        firstSrvctrNoList: rowList,
        srvClsfyCodeList: srvClsfyCode,
        ctrStatus: SgkbConstains.CODE.CNTRCT_STATUS.ACTIVEONLY,  // 契約状況：'1'(現在契約中のみ)
        contractlistSortPatterncode: SgkbConstains.CODE.CNTRCT_LIST_SORT_PTRN_CD.HOUKATSU_CNTRCT,  //契約一覧ソートパターンコード:'1'(包括契約)
      }
    }
    return sgkb986aRequest;
  }

  /**
   * 追加ボタン押下処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  onClickAdd(): void {
    const ref = this.dialog.open(Sgkb713dComponent, {
      height: '1050px',
      width: '1500px',
      disableClose: true,
    });
    ref.afterClosed().subscribe((result) => {
      if (result && result != '') {
        // 需給契約一覧登録用のリスト設定
        const sgkb713dInfoList = this.setIndCtrInfoList(result);
        // 需給契約の重複チェック
        const chkResult = this.chkDuplication();
        // 重複チェックがエラーの場合、処理終了
        if (chkResult) {
          return;
        }
        // 需給契約一覧登録用のリストを画面に反映
        this.setDataSourceView(sgkb713dInfoList);
      }
    }),
      catchError((err) => {
        this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB, SgkbConstains.MESSAGE.APINAME_SGKB708A);
        return throwError(err.message);
      })
  }

  /**
   * 需給契約一覧追加時の更新処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  setIndCtrInfoList(result: any): Array<NewSgkb702aResInclusiontargetDemandctrinfoDto> {
    const data = this.dataSource.data;

    let sgkb713dInfoList: Array<NewSgkb702aResInclusiontargetDemandctrinfoDto> = [];
    this.errorfirstSrvctrNoList = [];

    for (let i = 0; i < result.length; i++) {
      /** 需給契約検索画面 戻り値用 */
      let sgkb713dInfo: NewSgkb702aResInclusiontargetDemandctrinfoDto = {
        inclusioncontractSupplydemandcontractSrno: '',
        discountextraStartdate: '',
        discountextraUnlockdate: '',
        discountextraMny: null,
        discountextraRate: null,
        firstSrvctrNo: '',
        visitName: '',
        description: '',
        mptAname: '',
        townAreaName: '',
        ooazaName: '',
        chomeanameIkaKanjitext: '',
        bunptgouKanjiText: '',
        supadrKanjiAname1: '',
        yagouAname: '',
        energyClscode: '',
        energyClsfyCodeaname: '',
        heat: '',
        heatAname: '',
        prdBreakDate: '',
        prdCode: '',
        prdGoodsRyaku: '',
        suppntSpno: '',
        firstKenshinscheduledate: '',
        logicDeviceNo: '',
        visitNo: '',
        recptFixNo: '',
        keiyakuJotai: '',
        pipe: '',
        unitHeat: '',
        unitMny: '',
        unitRate: '',
        registFlg: false,
      };

      // 契約お客さま番号
      sgkb713dInfo.firstSrvctrNo = result[i].description.firstSrvctrNo;
      // 請求お客さま番号
      sgkb713dInfo.recptFixNo = result[i].description.recptFixNo;
      // 内部お客さま番号
      sgkb713dInfo.visitNo = result[i].ctrperInfo.visitNo;
      // 都道府県名称
      sgkb713dInfo.description = result[i].empposInfo.description;
      // 市区郡町村名称
      sgkb713dInfo.mptAname = result[i].empposInfo.mptAname;
      // 町域名称
      sgkb713dInfo.townAreaName = result[i].empposInfo.townAreaName;
      // 大字丁目名称
      sgkb713dInfo.ooazaName = result[i].empposInfo.ooazaName;
      // 丁目番地以下漢字テキスト
      sgkb713dInfo.chomeanameIkaKanjitext = result[i].empposInfo.bantiGoubunptgouAname;
      // 住宅・棟号漢字テキスト
      sgkb713dInfo.supadrKanjiAname1 = result[i].empposInfo.supadrKanjiAname1;
      // 屋号・業種・目標（漢字）
      sgkb713dInfo.yagouAname = result[i].empposInfo.yagouAname;
      // お客さま漢字氏名
      sgkb713dInfo.visitName = result[i].ctrperInfo.visitName;
      // エネルギー種別コード
      sgkb713dInfo.energyClscode = result[i].description.energyClscode;
      // エネルギー種別コード名称
      sgkb713dInfo.energyClsfyCodeaname = result[i].description.energyClsfyCodeaname;
      // 熱量
      sgkb713dInfo.heat = result[i].description.heat;
      // 熱量名称
      sgkb713dInfo.heatAname = result[i].description.heatAname;
      // サービス契約解約日付（契約終了日付を設定）
      sgkb713dInfo.prdBreakDate = result[i].description.ctrendDate;
      // プロダクト商品略称名称
      sgkb713dInfo.prdGoodsRyaku = result[i].description.prdGoodsRyaku;
      // 供給地点特定番号
      sgkb713dInfo.suppntSpno = result[i].empposInfo.extCnnctNo;
      // 送配電事業者コード
      sgkb713dInfo.transCode = result[i].description.transCode;
      // 検針日区分
      sgkb713dInfo.ksdateDiv = result[i].description.ksdateDiv;
      // 基本検針日
      sgkb713dInfo.basicKensinDay = result[i].description.basicKensinDay;
      // 導管事業者コード
      sgkb713dInfo.cndtBusCode = result[i].description.cndtBusCode;
      // 指定日検針日区分コード
      sgkb713dInfo.siteiKensinDiv = result[i].description.siteiKensinDiv;
      // 検針日程
      sgkb713dInfo.kensinSchdl = result[i].description.kensinSchdl;
      // 新規追加フラグ
      sgkb713dInfo.registFlg = true;

      // 需給契約一覧内で重複する契約お客さま番号が存在するか抽出
      const searchResult = data.find(search => search.firstSrvctrNo === sgkb713dInfo.firstSrvctrNo);
      if (searchResult && searchResult != undefined) {
        this.errorfirstSrvctrNoList.push(searchResult.firstSrvctrNo);
      }

      sgkb713dInfoList.push(sgkb713dInfo);
    }
    // 需給契約一覧編集
    sgkb713dInfoList = this.editIndCtrTable(sgkb713dInfoList, 'sgkb713d');
    return sgkb713dInfoList;
  }

  /**
   * 需給契約の重複チェック処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  chkDuplication(): boolean {
    let chkResult: boolean = false;
    if (this.errorfirstSrvctrNoList.length > 0) {
      // 重複対象となった契約お客さま番号を連結する
      const messageStr = this.errorfirstSrvctrNoList.join(',');

      this.clearMessageEvent.emit('');
      this.setMessageEvent.emit('契約番号：' + messageStr + 'の需給契約は、重複しているため、包括契約需給契約一覧に追加することはできません。');
      chkResult = true;

      return chkResult;
    }
  }

  /**
   * 需給契約一覧の画面西行が処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  setDataSourceView(sgkb713dInfoList: Array<NewSgkb702aResInclusiontargetDemandctrinfoDto>): void {
    const data = this.dataSource.data;

    for (let i = 0; i < sgkb713dInfoList.length; i++) {
      // 設定した情報を包括対象需給契約情報リストに追加
      data.push(sgkb713dInfoList[i]);
    }
    // 包括対象需給契約情報リストを再定義し、需給契約一覧を再描画
    this.dataSource.data = [...data];
    this.dataSourceChange.emit(this.dataSource);
  }

  /**
   * 編集ボタン押下処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  onClickEdit(selection: any): void {
    // 選択されたレコードを抽出
    const selected = selection.selected;
    // 先頭レコードを検索基準に設定
    const base = selected[0];
    // 選択されたレコードの割引・割増開始日を保持する
    this.befWaribikiKaishiYMD = base.discountextraStartdate;
    // エネルギー種別コード または 熱量 が異なるレコードを抽出
    const differentItems = selected.filter(item =>
      base.energyClscode !== item.energyClscode || base.heat !== item.heat
    );
    // 異なるレコードがある場合
    if (differentItems.length > 0) {
      this.clearMessageEvent.emit('');
      this.setMessageEvent.emit('包括契約情報の編集は、同一のエネルギー種別,熱量を選択してください。');
      return;
    }

    const ref = this.dialog.open(Sgkb714dComponent, {
      height: '400px',
      width: '900px',
      disableClose: true,
      data: {
        send: this.showKingaku, mode: this.mode, startDate: base.discountextraStartdate,
        unlockDate: base.discountextraUnlockdate,
        mny: base.discountextraPointMny, rate: base.discountextraRate, registFlg: base.registFlg
      },
    });
    ref.afterClosed().subscribe((result) => {
      if (result && result != '') {
        // 割引・割増開始日（一括設定画面の戻り値）
        const workWaribikiKaishiYMD =
          this.timeApiService.convertDateToString(result.waribikiKaishiYMD?.value);
        // 割引・割増解除日（一括設定画面の戻り値）
        const workWaribikiKaijoYMD =
          this.timeApiService.convertDateToString(result.waribikiKaijoYMD?.value);

        selected.map((item: any) => {
          const isSelected = selection.selected.find((sel: any) => sel.firstSrvctrNo === item.firstSrvctrNo);
          if (!isSelected) return of(item); // 選択されていない場合はそのまま返す
          // 保持した割引・割増開始日と割引・割増一括設定画面からの戻り値の割引・割増開始日が一致する場合は年間スケジュールマスタを呼び出さない
          if (this.befWaribikiKaishiYMD === workWaribikiKaishiYMD) {
            // 割引・割増開始日
            item.discountextraStartdate = workWaribikiKaishiYMD;
            // 割引・割増解除日
            item.discountextraUnlockdate = workWaribikiKaijoYMD;
            // 割引・割増金額
            item.discountextraPointMny = result.waribikiKingaku?.value;
            // 割引・割増率
            if (typeof result.waribikiKingaku?.value === 'string') {
              item.discountextraRate = Number(result.waribikiRitsu?.value.replace(/,/g, ''));
            } else {
              item.discountextraRate = result.waribikiRitsu?.value;
            }
            // 割引・割増金額の単位
            item.unitMny = this.showKingaku === true ? '円' : '';
            // 割引・割増率
            item.unitRate = this.showKingaku !== true ? '％' : '';

            const updatedData = this.dataSource.data.map((dataItem: any) => {
              return dataItem.firstSrvctrNo === item.firstSrvctrNo ? { ...dataItem, ...item } : dataItem;
            });
            // 包括対象需給契約情報リストを再定義し、需給契約一覧を再描画
            this.dataSource.data = updatedData;
            this.dataSourceChange.emit(this.dataSource);
            // 編集ボタン非活性
            this.isEditDisabled = true;
            // 削除ボタン非活性
            this.isDelDisabled = true;
          } else {
            // 年間スケジュールマスタのリクエスト設定（初回時）
            let szza024aRequest: Szza024aRequest =
              this.setSzza024aRequest(isSelected, workWaribikiKaishiYMD, 0);

            // 年間スケジュールマスタのサービス呼び出し
            this.usedSzza024aService.searchNenkanSchedule(szza024aRequest)
              .pipe(take(1))
              .subscribe(response => {
                // 年間スケジュールマスタの日付取得
                const date: string = response[0].date;

                // 年間スケジュールマスタ サービス再実行判定フラグ
                let usedSzza024aServiceReStart: boolean = false;

                // （エネルギー種別コードが ガス または ＬＰ） かつ
                // 年間スケジュールマスタから取得した日付が割引・割増開始日より当日を含む過去日の場合
                if ((isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS || isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.LP_GAS)
                  && date <= workWaribikiKaishiYMD) {
                  usedSzza024aServiceReStart = true;
                }
                // エネルギー種別コードが 電気 かつ
                // 年間スケジュールマスタから取得した日付が割引・割増開始日より当日を含まない過去日の場合
                else if (isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.ELE && date < workWaribikiKaishiYMD) {
                  usedSzza024aServiceReStart = true;
                }

                if (usedSzza024aServiceReStart) {
                  // 年間スケジュールマスタのリクエスト設定（月＋１）
                  let szza024aRequest: Szza024aRequest =
                    this.setSzza024aRequest(isSelected, workWaribikiKaishiYMD, 1);

                  // 年間スケジュールマスタのサービス呼び出し
                  this.usedSzza024aService.searchNenkanSchedule(szza024aRequest)
                    .pipe(take(1))
                    .subscribe(response => {
                      const date: string = response[0].date;

                      // 初回検針日
                      item.firstKenshinscheduledate = date;
                      // 割引・割増開始日
                      item.discountextraStartdate = workWaribikiKaishiYMD;
                      // 割引・割増解除日
                      item.discountextraUnlockdate = workWaribikiKaijoYMD;
                      // 割引・割増金額
                      item.discountextraPointMny = result.waribikiKingaku?.value;
                      // 割引・割増率
                      if (typeof result.waribikiKingaku?.value === 'string') {
                        item.discountextraRate = Number(result.waribikiRitsu?.value.replace(/,/g, ''));
                      } else {
                        item.discountextraRate = result.waribikiRitsu?.value;
                      }
                      // 割引・割増金額の単位
                      item.unitMny = this.showKingaku === true ? '円' : '';
                      // 割引・割増率
                      item.unitRate = this.showKingaku !== true ? '％' : '';

                      const updatedData = this.dataSource.data.map((dataItem: any) => {
                        return dataItem.firstSrvctrNo === item.firstSrvctrNo ? { ...dataItem, ...item } : dataItem;
                      });
                      // 包括対象需給契約情報リストを再定義し、需給契約一覧を再描画
                      this.dataSource.data = updatedData;
                      this.dataSourceChange.emit(this.dataSource);
                      // 編集ボタン非活性
                      this.isEditDisabled = true;
                      // 削除ボタン非活性
                      this.isDelDisabled = true;
                      // チェックボックスの選択解除
                      selection.clear();
                      return;
                    });
                }

                // 初回検針日
                item.firstKenshinscheduledate = date;
                // 割引・割増開始日
                item.discountextraStartdate = workWaribikiKaishiYMD;
                // 割引・割増解除日
                item.discountextraUnlockdate = workWaribikiKaijoYMD;
                // 割引・割増金額
                item.discountextraPointMny = result.waribikiKingaku?.value;
                // 割引・割増率
                if (typeof result.waribikiKingaku?.value === 'string') {
                  item.discountextraRate = Number(result.waribikiRitsu?.value.replace(/,/g, ''));
                } else {
                  item.discountextraRate = result.waribikiRitsu?.value;
                }
                // 割引・割増金額の単位
                item.unitMny = this.showKingaku === true ? '円' : '';
                // 割引・割増率
                item.unitRate = this.showKingaku !== true ? '％' : '';

                const updatedData = this.dataSource.data.map((dataItem: any) => {
                  return dataItem.firstSrvctrNo === item.firstSrvctrNo ? { ...dataItem, ...item } : dataItem;
                });
                // 包括対象需給契約情報リストを再定義し、需給契約一覧を再描画
                this.dataSource.data = updatedData;
                this.dataSourceChange.emit(this.dataSource);
                // 編集ボタン非活性
                this.isEditDisabled = true;
                // 削除ボタン非活性
                this.isDelDisabled = true;
                // チェックボックスの選択解除
                selection.clear();
              });
            // 変更検出を行い、ビューとデータの整合性を確保
            this.cdr.detectChanges();

          }
        })
        // チェックボックスの選択解除
        selection.clear();
        // 変更検出を行い、ビューとデータの整合性を確保
        this.cdr.detectChanges();
      }
    });

  }


  /**
   * 年間スケジュールマスタのリクエスト設定
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  setSzza024aRequest(isSelected: any, workWaribikiKaishiYMD: string,
    addMonth: number): Szza024aRequest {

    let workDateDiscrm: string = '';
    let workGrpNo: string = '';
    let workYear: string = workWaribikiKaishiYMD?.slice(0, 4);
    let workMonth: string = (Number(workWaribikiKaishiYMD?.slice(4, 6)) + addMonth).toString().padStart(2, '0');

    // エネルギー種別コードが ガス または LP の場合
    if (isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS || isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.LP_GAS) {
      // 指定日検針日区分コードが ー の場合は末尾に 0、ー 以外の場合は末尾に 1 を設定
      workDateDiscrm = 'G' + isSelected.suppntSpno.slice(0, 3) + (isSelected.siteiKensinDiv === '00' ? '0' : '1');
      // 指定日検針日区分コードが ー の場合は 検針日程、ー 以外の場合は 指定日検針日区分コード を設定
      workGrpNo = isSelected.siteiKensinDiv === '00' ? isSelected.kensinSchdl : isSelected.siteiKensinDiv;
    }
    // エネルギー種別コードが 電気 の場合
    else if (isSelected.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.ELE) {
      // 検針日区分が 繰上 の場合は末尾に 00、繰上 以外の場合は末尾に 10 を設定
      workDateDiscrm = 'E' + isSelected.suppntSpno.slice(0, 2) + (isSelected.ksdateDiv === '1' ? '00' : '10');
      // 基本検針日を設定
      workGrpNo = isSelected.basicKensinDay;
    }

    // リクエストを作成
    const request: Szza024aRequest = {
      nenkanSchdlMasterSrchInfDto: {
        dateDiscrm: workDateDiscrm,
        grpNo: workGrpNo,
        year: workYear,
        month: workMonth,
      }
    };
    return request;
  }

  /**
   * 削除ボタン押下処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  onClickDel(selection: any): void {
    // 選択されたレコードを抽出
    const selected = selection.selected;
    // 選択されているアイテムをフィルタリングして削除
    this.dataSource.data = this.dataSource.data.filter(item => !selected.includes(item));
    // 選択解除
    selection.clear();
    // 編集、削除ボタンを非活性
    this.isEditDisabled = true;
  }

  /**
   * チェックボックス押下時の処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  onChangeSelection(event: any, selection: any): void {
    if (event) {
      // チェックボックスが選択されている場合
      if (selection.hasValue()) {
        // 編集ボタン活性
        this.isEditDisabled = false;
        // 期中変更の場合
        if (this.mode === 'midterm_change') {
          // 削除ボタン非活性
          this.isDelDisabled = true;
        } else {
          // 削除ボタン活性
          this.isDelDisabled = false;
        }
      } else {
        // 編集ボタン非活性
        this.isEditDisabled = true;
        // 削除ボタン非活性
        this.isDelDisabled = true;
      }

      this.onSelectedEvent.emit(
        selection.selected.sort((a, b) => {
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
        })
      );
    }
  }

  /**
   * すべて選択／選択解除の切り替え処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  masterToggle(selection: any, dataSource: any) {
    this.isAllSelected(selection, dataSource) ?
      selection.clear() :
      dataSource.data.forEach(row => selection.select(row));
  }
  /**
   * 全選択状態かの判定処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  isAllSelected(selection: any, dataSource: any) {
    const numSelected = selection.selected.length;
    const numRows = dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * 選択行のチェックボックスラベル処理
   * @memberof Sgkb708dInclutagsupdemandctrComponent
   */
  checkboxLabel(selection: any, dataSource: any, row?: any): string {
    if (!row) {
      return `${this.isAllSelected(selection, dataSource) ? 'select' : 'deselect'} all`;
    }
    return `${selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }
}
